import { render, staticRenderFns } from "./account-users-dashboard.vue?vue&type=template&id=2c83ec54&"
import script from "./account-users-dashboard.vue?vue&type=script&lang=js&"
export * from "./account-users-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports